import React from "react";
import { Link } from "react-router-dom";
import { Button, Col, Row } from "reactstrap";
import logo from "../../../assets/orderingSystem/logo-1.png";

const ThemeFooter = ({ apiResponse }) => {
  return (
    <div className="">
      {/* FREE WEBSITE OFFER (Only if not paid) */}
      {apiResponse && !apiResponse.organization.isPaid && (
        <>
          <Row className="justify-content-center mb-2">
            <Col lg={6} sm={8} xs={12} className="text-center">
              <p className="mb-1" style={{ fontSize: "13px" }}>
                Create a similar website at <strong>ZERO</strong> cost.
              </p>
              <Link to="/register">
                <Button color="warning" size="sm" className="fw-bold">
                  Get Started Now
                </Button>
              </Link>
            </Col>
          </Row>
        </>
      )}

      {/* COMPACT POWERED BY FOOTER */}
      <div className="bg-dark text-center py-2" style={{  }}>
        <h6
          className="text-secondary mb-1"
          style={{ fontStyle: "italic", fontSize: "18px" }}
        >
          Powered by
        </h6>

        <img
          src={logo}
          alt="Danfe Logo"
          className="img-fluid"
          style={{ height: "48px" }} // small logo reduces height
        />
      </div>
    </div>
  );
};

export default ThemeFooter;
